export class WorkflowStatusRequest {

  processType: string;
  interactive?: boolean;

  candidateId?: number;
  jobReqId?: number;
  userId?: number;
}

export class OnboardStatus {

  candidateId: number;
  candidateName: string;
  currentStatus: string;
  position: string;
  hiringManagerId: number;
  hiringManagerName: string;
  dueDate: Date;
}
